module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADVSURBVHgBrVMBDcIwEPwmCKgDJgEJlYAD5oQ5GCjYUAAOkEBQUByAg/KfXZOn0FEaLrlsbe8vf/2N6B8IITTMFdWCi12YsKFacHGrTbA+g4N0+ZMJYq3R3cj0zP6bwQDhWxwYXkSTK95CYNM4SmOh6emDu485IQwznYjWyXqBfSm0SifvD+aeKfnJGHNQ5zfwxXkXI2DdMe+gns5RzihzDyNMGhXFJtOxNAd04jERh1H2aScRJmPS8KNjLrF1ZZ5ouisZY5vcSTlUHEe1kB8vlHzaJXgChh8qqIBOmVYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/eyes-close.png
// module id = ANGJ
// module chunks = 0